import { Button as PrimeReactButton } from "primereact/button";
import styled, { keyframes, css } from "styled-components";

const baseButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 42px;
  white-space: nowrap;
  background-color: ${(props) => props.theme.palette.button.primary};
  cursor: pointer;
  border-radius: 999px;
`;

const StyledButton = styled(PrimeReactButton)`
  ${baseButtonStyles};
`;

// Animated 6-color gradient for "Create release" buttons
const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
`;

export const CreateReleaseButton = styled(PrimeReactButton)`
  ${baseButtonStyles};
  padding: 0.85rem 2.6rem;
  font-weight: 600;
  font-size: 14px;
  border: none;
  color: #ffffff;
  background: linear-gradient(
    270deg,
    #a855f7 0%,
    #6366f1 16%,
    #22c1c3 33%,
    rgb(87, 167, 229) 50%,
    rgb(210, 121, 245) 67%,
    rgb(143, 49, 238) 84%,
    #a855f7 100%
  );
  background-size: 220% 220%;
  animation: ${gradientShift} 20s linear infinite;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

  &:hover {
    transform: translateY(-1px) scale(1.03);
    filter: brightness(1.06);
  }

  &:active {
    transform: translateY(0) scale(0.99);
    
  }

  /* PrimeReact adds a default focus ring/box-shadow (often blue) on mouse click.
     We remove it for :focus, but keep a visible indicator for keyboard users via :focus-visible. */
  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(103, 119, 255, 0.35);
  }
`;

export const Button = StyledButton;
